import { render, staticRenderFns } from "./StandardBooking.vue?vue&type=template&id=70e32dd2"
import script from "./StandardBooking.vue?vue&type=script&lang=js"
export * from "./StandardBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports